const doc = [({"en":({"js":({"admin":({"logs":({"card":({"log":"Log"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;